import { removeQueryParams } from './removeQueryParams'

/**
 * Returns a normalized avatar URL.
 *
 * - If the avatar is a full HTTPS URL, query parameters are removed.
 * - If the avatar is a relative path, it is prefixed with the base image URL from environment variables.
 * - If the avatar is not provided, an empty string is returned.
 *
 * @param {string} [avatar] - The avatar URL or relative path.
 * @returns {string} The processed avatar URL or an empty string if not available.
 */
export function getUserAvatarUrl(avatar?: string): string {
  if (!avatar) {
    return ''
  }

  return avatar.startsWith('https')
    ? removeQueryParams(avatar)
    : `${process.env.REACT_APP_IMAGE_BASE_URL}/${avatar}`
}
